import { BindSbpTokenOptionsV2 } from '../types';
import { createVerificationIntent } from '../utils/createVerificationIntent';

export const createSbpTokenBindingApi2 = async (apiHost: string, params: BindSbpTokenOptionsV2) => {
    return createVerificationIntent(apiHost, {
        ...params,
        flow: 'sbp',
    });
};
